import { render, staticRenderFns } from "./SelecaoPrestadoresProcedimentos.vue?vue&type=template&id=b1e8b8d2&"
import script from "./SelecaoPrestadoresProcedimentos.vue?vue&type=script&lang=js&"
export * from "./SelecaoPrestadoresProcedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports